export const AND = "AND";
export const OR = "OR";
export const NOT = "NOT";
export const CONDITION = "Condition";
export const OUTPUT = "Output";
export const CONSTANT = "Constant";
export const VARIABLE = "Variable";
export const LOGIC = "Logic";
export const DEBUG = "Debug";